export default __webpack_public_path__ + "media/src/assets/images/cancel-a42c7cef56f33a810368bd621971fa46.svg";